module.exports = __webpack_public_path__ + "static/learning_room_1-c5f49a34c93babe6d0efdfbb072bf642.jpg";